import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import BlogHero from "./sections/BlogHero";
import BlogPosts from "./sections/BlogPosts";
import SubscribeCta from "./sections/SubscribeCta";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <BlogHero />
      <BlogPosts />
      <SubscribeCta />
      <Footer />
    </div>;
}